module.exports = __webpack_public_path__ + "img/warning.f01a31cf.png";